<template>
  <div class="example zero-card p-x2">
    <h4>{{ titleProp }}</h4>
    <p>
      {{ descProp }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ExampleComponent',
  props: {
    titleProp: {
      type: String,
      default: 'no prop string provided'
    },
    descProp: {
      type: String,
      default: 'no prop string provided'
    }
  },
  data () {
    return {
      myValue: 'Hello'
    }
  },
  components: {
  },
  created () {},
  computed: {},
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
